{
	"titles": {
		"assurance": "Assure cycle",
		"requestInformation": "Request information for the cycle",
		"rejection": "Reject cycle"
	},
	"descriptions": {
		"assurance": "Please review the data below to confirm that you are assuring the correct transaction.",
		"requestInformation": "Please review the data below to confirm that you are requesting additional information for the correct transaction.",
		"rejection": "Please review the data below to confirm that you are rejecting the correct transaction."
	},
	"cycleReviewDetailsCard": {
		"title": "Cycle",
		"cycleNumberTitle": "Cycle ID",
		"shipmentDateTitle": "Shipment date",
		"plantTitle": "Plant"
	},
	"carbonReductionsDetailsCard": {
		"title": "CO2 pumped net to storage",
		"totalTitle": "Total",
		"biogenicTitle": "Biogenic",
		"fossilTitle": "Fossil",
		"timestampTitle": "Timestamp"
	},
	"cycleAssuranceForm": {
		"title": "Assurance documentation",
		"serialNumberLabel": "Add assurance serial number",
		"serialNumberPlaceholder": "DNV-2025-ABC-123456789",
		"errors": {
			"serialNumberRequired": "Serial number is required",
			"serialNumberInvalid": "Serial number format is DNV-YYYY-ABC-123456789"
		}
	},
	"cycleRequestInformationForm": {
		"commentPlaceholder": "Please describe the required information?",
		"errors": {
			"commentRequired": "Comment is required"
		}
	},
	"cycleRejectionForm": {
		"commentPlaceholder": "Please explain why the cycle was not assured",
		"alertDescription": "Once an cycle is rejected, it cannot be reset thereafter, as it is a one-time action. Therefore, it is essential to ensure that your decision is accurate.",
		"errors": {
			"commentRequired": "Comment is required"
		}
	},
	"submitToasts": {
		"assurance": "The cycle #{{cycleNumber}} is pending assurance.",
		"requestInformation": "Request for cycle #{{cycleNumber}} got sent.",
		"rejection": "The cycle #{{cycleNumber}} got rejected.",
		"error": "Failed to modify cycle status."
	},
	"cycleReviewActionButtons": {
		"cancelTitle": "Cancel",
		"assuranceTitle": "Assure",
		"requestInformationTitle": "Request information",
		"rejectionTitle": "Reject"
	}
}
